var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(_vm.navbarcomponent, {
    tag: "component",
    attrs: { "help-active": _vm.helpActive },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }